import { render, staticRenderFns } from "./InfoautoOrdersPage.vue?vue&type=template&id=767bd12f&scoped=true"
import script from "./InfoautoOrdersPage.vue?vue&type=script&lang=js"
export * from "./InfoautoOrdersPage.vue?vue&type=script&lang=js"
import style0 from "./InfoautoOrdersPage.vue?vue&type=style&index=0&id=767bd12f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767bd12f",
  null
  
)

export default component.exports